/**
 * @file index.tsx
 *
 * @fileoverview Renders an AI generated site paragraph row on the page.
 */

import React from 'react';
import { AiGeneratedSiteParagraph } from '~/jobiqo/models/landingAi';
import AiGeneratedSiteParagraphLoading from '~/jobiqo/components/Landingpage/AiGeneratedSiteParagraph/Loading';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';

export interface AiGeneratedSiteParagraphRowProps {
  /**
   * The row element (from the backend landing page row).
   */
  row: AiGeneratedSiteParagraph;
}

/**
 * Renders the body of an AI generated site paragraph, and nothing else.
 *
 * Always full width: the body is a self-contained section styled inline, so
 * no container or spacing is added around it. The backend purifies generated
 * markup before storing it, and WYSIWYGText sanitizes it again with DOMPurify
 * on render.
 *
 * While the visual editor reports a generation for this section, the loading
 * state takes its place: replacing the old content rather than overlaying it
 * says plainly that this section is being rewritten.
 */
export const AiGeneratedSiteParagraphRow = ({
  row: { body, aiPreviewLoading },
}: AiGeneratedSiteParagraphRowProps) => {
  if (aiPreviewLoading) {
    return <AiGeneratedSiteParagraphLoading />;
  }

  if (!body) {
    return null;
  }

  return <WYSIWYGText format="full_html" content={body} />;
};

export default AiGeneratedSiteParagraphRow;
